import React from 'react';
import { Close8 } from '@yunex/yds-icons';
import { blue20opacity15, blue50, blue60 } from '../../../colors/blue';
import { gray40opacity10, gray80 } from '../../../colors/gray';
import { green02opacity20, green04 } from '../../../colors/green';
import { orange02opacity30, orange04 } from '../../../colors/orange';
import { red02opacity20, red04 } from '../../../colors/red';
import { yellow02opacity30, yellow04 } from '../../../colors/yellow';
import { shape } from '../shape';
import { rem } from '../../../utils/rem';
export var MuiChip = {
    defaultProps: { deleteIcon: React.createElement(Close8, null) },
    styleOverrides: {
        root: {
            backgroundColor: gray40opacity10,
            borderRadius: shape === null || shape === void 0 ? void 0 : shape.borderRadius,
            height: rem(22),
            '&[class*=Mui-focusVisible]': {
                outline: "".concat(rem(1), " solid ").concat(blue60),
            },
        },
        sizeSmall: {
            height: rem(18),
        },
        label: {
            fontSize: rem(12),
            fontWeight: 500,
            paddingBlock: 0,
            paddingInline: rem(12),
        },
        labelSmall: {
            fontSize: rem(10),
            paddingBlock: 0,
            paddingInline: rem(8),
        },
        icon: {
            width: rem(16),
            height: rem(16),
        },
        deleteIcon: {
            flexShrink: 0,
            height: rem(8),
            margin: 0,
            marginInlineEnd: rem(12),
            width: rem(8),
        },
    },
    customOverrides: {
        rounded: {
            borderRadius: rem(50),
        },
        colorNeutral: {
            color: gray80,
        },
        colorBlue: {
            backgroundColor: blue20opacity15,
            color: blue50,
        },
        colorGreen: {
            backgroundColor: green02opacity20,
            color: green04,
        },
        colorYellow: {
            backgroundColor: yellow02opacity30,
            color: yellow04,
        },
        colorOrange: {
            backgroundColor: orange02opacity30,
            color: orange04,
        },
        colorRed: {
            backgroundColor: red02opacity20,
            color: red04,
        },
    },
};
